import { render, staticRenderFns } from "./OrganizerSideNavPanel.vue?vue&type=template&id=5b40b11e"
import script from "./OrganizerSideNavPanel.vue?vue&type=script&lang=ts"
export * from "./OrganizerSideNavPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports